import { createSelector } from 'selectors'

import { constants } from './lazy-select.constant'

export const getTargets = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLSelectElement>>({ scope, selector: constants.selector.target }, true)

export const getLabel = (scope?: HTMLElement) =>
	createSelector<HTMLLabelElement | null>({ scope, selector: constants.selector.label })

export const getRender = (scope?: HTMLElement) =>
	createSelector<HTMLLabelElement>({ scope, selector: constants.selector.render })

export const getDynamicOptions = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLOptionElement>>({ scope, selector: constants.selector.dynamicOptionAttribute }, true)

export const getDynamicOptionWithValue = (value: string, scope?: HTMLElement) =>
	Array.from(
		createSelector<NodeListOf<HTMLOptionElement>>(
			{ scope, selector: constants.selector.dynamicOptionAttribute },
			true,
		).values(),
	).find((option) => option.value === value)
